import classNames from 'classnames'

export default function QuantityDisplay({
    quantity,
    greenWhenPositive = false,
    disabledLabel,
    unlimitedLabel,
    grayLabel,
    label,
}) {
    // Format number to display with spaces as thousands separator
    const formattedQuantity = [
        new Intl.NumberFormat('fr-FR').format(quantity),
        label,
    ].join(' ')

    // Set the color of the quantity based on the value of greenWhenPositive
    const quantityColor = greenWhenPositive
        ? quantity > 0
            ? 'text-green-500'
            : 'text-red-500'
        : quantity < 0
        ? 'text-red-500'
        : ''

    const quantityClasses = classNames(quantityColor)

    if (unlimitedLabel) {
        return <span className="text-green-500">{unlimitedLabel}</span>
    }

    if (disabledLabel) {
        return <span className="text-red-500">{disabledLabel}</span>
    }

    if (grayLabel) {
        return <span className="text-gray-400">{grayLabel}</span>
    }

    if (quantity === null) {
        return <span className="text-gray-300">-</span>
    }

    return <span className={quantityClasses}>{formattedQuantity}</span>
}
